.atm_26_1x778eo{background:white;}
.atm_3f_glywfm{border:none;}
.atm_5j_ftgil2{border-radius:8px;}
.atm_70_1xqlxq8{box-shadow:0px 8px 12px 6px rgba(0, 33, 82, 0.15),0px 4px 4px 0px rgba(0, 0, 0, 0.25);}
.atm_ks_1wugsn5{overflow:auto;}
.atm_wq_jbo96x{z-index:100000;}
.atm_w8mpmz_glywfm:focus{outline:none;}
